var exports = {
  "Ve": "ThemeTab.module__themeButtonGroup___QkxZbV",
  "mB": "ThemeTab.module__themeButton___QkxZbV",
  "RL": "ThemeTab.module__themeButtonSelected___QkxZbV",
  "Uk": "ThemeTab.module__themeButtonLight___QkxZbV",
  "sy": "ThemeTab.module__themeButtonDark___QkxZbV",
  "H2": "ThemeTab.module__themeButtonIcon___QkxZbV",
  "zO": "ThemeTab.module__themeButtonCheckmark___QkxZbV",
  "Qs": "ThemeTab.module__themeButtonCheckmarkIcon___QkxZbV",
};

module.exports = exports;
